"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var account_1 = require("../../../account");
var operation_1 = require("../../../operation");
var currencies_1 = require("../../../currencies");
var Ethereum_1 = require("../../../api/Ethereum");
var Fees_1 = require("../../../api/Fees");
var transaction_1 = require("../transaction");
var synchronisation_1 = require("../synchronisation");
var modules_1 = require("../modules");
var signOperation_1 = require("../signOperation");
var modules_2 = require("../modules");
var postSyncPatch_1 = __importDefault(require("../postSyncPatch"));
var range_1 = require("../../../range");
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
var broadcast = function (_a) {
    var account = _a.account, _b = _a.signedOperation, operation = _b.operation, signature = _b.signature;
    return __awaiter(void 0, void 0, void 0, function () {
        var api, hash;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    api = (0, Ethereum_1.apiForCurrency)(account.currency);
                    return [4 /*yield*/, api.broadcastTransaction(signature)];
                case 1:
                    hash = _c.sent();
                    return [2 /*return*/, (0, operation_1.patchOperationWithHash)(operation, hash)];
            }
        });
    });
};
var scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: synchronisation_1.getAccountShape });
var sync = (0, jsHelpers_1.makeSync)({ getAccountShape: synchronisation_1.getAccountShape, postSync: postSyncPatch_1["default"] });
var createTransaction = function () { return ({
    family: "ethereum",
    mode: "send",
    amount: new bignumber_js_1.BigNumber(0),
    recipient: "",
    gasPrice: null,
    userGasLimit: null,
    estimatedGasLimit: null,
    networkInfo: null,
    feeCustomUnit: (0, currencies_1.getCryptoCurrencyById)("ethereum").units[1],
    useAllAmount: false,
    feesStrategy: "medium"
}); };
var updateTransaction = function (t, patch) {
    if ("recipient" in patch && patch.recipient !== t.recipient) {
        return __assign(__assign(__assign({}, t), patch), { userGasLimit: null, estimatedGasLimit: null });
    }
    return __assign(__assign({}, t), patch);
};
var getTransactionStatus = function (a, t) {
    var gasLimit = (0, transaction_1.getGasLimit)(t);
    var estimatedFees = (t.gasPrice || new bignumber_js_1.BigNumber(0)).times(gasLimit);
    var errors = {};
    var warnings = {};
    var result = {
        errors: errors,
        warnings: warnings,
        estimatedFees: estimatedFees,
        amount: new bignumber_js_1.BigNumber(0),
        totalSpent: new bignumber_js_1.BigNumber(0)
    };
    var m = modules_2.modes[t.mode];
    (0, invariant_1["default"])(m, "missing module for mode=" + t.mode);
    m.fillTransactionStatus(a, t, result);
    // generic gas error and warnings
    if (!t.gasPrice) {
        errors.gasPrice = new errors_1.FeeNotLoaded();
    }
    else if (gasLimit.eq(0)) {
        errors.gasLimit = new errors_1.FeeRequired();
    }
    else if (!errors.recipient) {
        if (estimatedFees.gt(a.balance)) {
            errors.gasPrice = new errors_1.NotEnoughGas();
        }
    }
    if (t.estimatedGasLimit && gasLimit.lt(t.estimatedGasLimit)) {
        warnings.gasLimit = new errors_1.GasLessThanEstimate();
    }
    return Promise.resolve(result);
};
var getNetworkInfoByOneGasPrice = function (c) { return __awaiter(void 0, void 0, void 0, function () {
    var gas_price, initial, gasPrice;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, Fees_1.getEstimatedFees)(c)];
            case 1:
                gas_price = (_a.sent()).gas_price;
                initial = new bignumber_js_1.BigNumber(gas_price);
                gasPrice = (0, range_1.inferDynamicRange)(initial);
                return [2 /*return*/, {
                        family: "ethereum",
                        gasPrice: gasPrice
                    }];
        }
    });
}); };
var getNetworkInfoByGasTrackerBarometer = function (c) { return __awaiter(void 0, void 0, void 0, function () {
    var api, _a, low, medium, high, minValue, maxValue, initial, gasPrice;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                api = (0, Ethereum_1.apiForCurrency)(c);
                return [4 /*yield*/, api.getGasTrackerBarometer()];
            case 1:
                _a = _b.sent(), low = _a.low, medium = _a.medium, high = _a.high;
                minValue = low;
                maxValue = high.lte(low) ? low.times(2) : high;
                initial = medium;
                gasPrice = (0, range_1.inferDynamicRange)(initial, {
                    minValue: minValue,
                    maxValue: maxValue
                });
                return [2 /*return*/, {
                        family: "ethereum",
                        gasPrice: gasPrice
                    }];
        }
    });
}); };
var getNetworkInfo = function (c) {
    return getNetworkInfoByGasTrackerBarometer(c)["catch"](function (e) {
        // TODO: drop this fallback when the API is 100% in production
        if (e.status === 404) {
            return getNetworkInfoByOneGasPrice(c);
        }
        throw e;
    });
};
var inferGasPrice = function (t, networkInfo) {
    return t.feesStrategy === "slow"
        ? networkInfo.gasPrice.min
        : t.feesStrategy === "medium"
            ? networkInfo.gasPrice.initial
            : t.feesStrategy === "fast"
                ? networkInfo.gasPrice.max
                : t.gasPrice || networkInfo.gasPrice.initial;
};
var prepareTransaction = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var networkInfo, _a, gasPrice, estimatedGasLimit, request;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = t.networkInfo;
                if (_a) return [3 /*break*/, 2];
                return [4 /*yield*/, getNetworkInfo(a.currency)];
            case 1:
                _a = (_b.sent());
                _b.label = 2;
            case 2:
                networkInfo = _a;
                gasPrice = inferGasPrice(t, networkInfo);
                if (t.gasPrice !== gasPrice || t.networkInfo !== networkInfo) {
                    t = __assign(__assign({}, t), { networkInfo: networkInfo, gasPrice: gasPrice });
                }
                request = (0, transaction_1.inferEthereumGasLimitRequest)(a, t);
                if (!request.to) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, transaction_1.estimateGasLimit)(a, request.to, request)];
            case 3:
                estimatedGasLimit = _b.sent();
                _b.label = 4;
            case 4:
                if (!t.estimatedGasLimit ||
                    (estimatedGasLimit && !estimatedGasLimit.eq(t.estimatedGasLimit))) {
                    t.estimatedGasLimit = estimatedGasLimit;
                }
                return [4 /*yield*/, (0, modules_1.prepareTransaction)(a, t)];
            case 5:
                t = _b.sent();
                return [2 /*return*/, t];
        }
    });
}); };
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var mainAccount, t, s;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
                    return [4 /*yield*/, prepareTransaction(mainAccount, __assign(__assign(__assign(__assign({}, createTransaction()), { subAccountId: account.type === "Account" ? null : account.id }), transaction), { recipient: (transaction === null || transaction === void 0 ? void 0 : transaction.recipient) || "0x0000000000000000000000000000000000000000", useAllAmount: true }))];
                case 1:
                    t = _b.sent();
                    return [4 /*yield*/, getTransactionStatus(mainAccount, t)];
                case 2:
                    s = _b.sent();
                    return [2 /*return*/, s.amount];
            }
        });
    });
};
var getPreloadStrategy = function (_currency) { return ({
    preloadMaxAge: 30 * 1000
}); };
var currencyBridge = {
    getPreloadStrategy: getPreloadStrategy,
    preload: modules_1.preload,
    hydrate: modules_1.hydrate,
    scanAccounts: scanAccounts
};
var accountBridge = {
    createTransaction: createTransaction,
    updateTransaction: updateTransaction,
    prepareTransaction: prepareTransaction,
    estimateMaxSpendable: estimateMaxSpendable,
    getTransactionStatus: getTransactionStatus,
    sync: sync,
    receive: receive,
    signOperation: signOperation_1.signOperation,
    broadcast: broadcast
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=js.js.map